import {TMatchingMode} from '@/api/swimLaneGroup';

export const matchingModeMap = new Map<TMatchingMode, string>([
    ['exact', '精确'],
    ['prefix', '前缀'],
    ['regex', '正则'],
]);
